import type { UseFormReturn } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { RaiseFormValues } from '../lib/raise-form-schema';

type Ctrl = UseFormReturn<RaiseFormValues>['control'];

// The QP month (metals only) and the precise prompt date. The prompt date is the
// exact day the hedge targets — offered for both metals and FX — and maps to the
// request's target_prompt_date. Both are optional.
export function ScheduleFields({ control, isFx }: Readonly<{ control: Ctrl; isFx: boolean }>) {
  return (
    <>
      {!isFx && (
        <FormField
          control={control}
          name="estimatedQpMonth"
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>Estimated QP Month</FormLabel>
              <FormControl>
                <Input type="month" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
      <FormField
        control={control}
        name="targetPromptDate"
        render={({ field }) => (
          <FormItem className="sm:col-span-2">
            <FormLabel>Prompt Date</FormLabel>
            <FormDescription>
              The exact prompt date this hedge targets. Optional — leave blank if not yet known.
            </FormDescription>
            <FormControl>
              <Input type="date" {...field} data-testid="raise-prompt-date" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
